import React from "react";
import { useParams } from "react-router-dom";
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../../../components/PageHeaderWithBreadcrumbs";

//import './style.css';

import DepartmentManagement from "./DepartmentManagement";

const EliteProductionDepartmentManagement = () => {
  const { instanceUniqueId } = useParams();

  return (
    <>
      <div className="instance-dashboard">
        <InstanceLeftSidebar />
        <div className="rightSide">
          <div className="options-container fade-in-effect-usability">
            <div className="options-inner-container">
              <PageHeaderWithBreadcrumbs
                title="Department Management"
                breadcrumb="Department Management"
                includeButton={false}
              />
              {/* <Container fluid> */}
              {/* <div>
              </div> */}
              {/* </Container> */}
              {/* Data Table Section for Web Stores */}
              {/* <p>Analytics design template to be developed</p> */}
              {/* <EliteMachinesUI2 /> */}
              {/* <EliteMachinesTab /> */}
              <DepartmentManagement instanceUniqueId={instanceUniqueId} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EliteProductionDepartmentManagement;
